import { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as actions from './actions'

export const useResume = () => {

    const {
        resumes,
        initialize,
        loadMore,
        limit,
        total,
        isRequesting,
        bio,
        display_qr_reels

    } = useSelector((state) => state.resume);

    const dispatch = useDispatch();

    const refreshResumes = useCallback(
        () => dispatch(actions.refreshResumes()),
        [dispatch]
    );

    const setResumes = useCallback(
        (payload) => dispatch(actions.setResumes(payload)),
        [dispatch]
    );

    const addResume = useCallback(
        (payload) => dispatch(actions.addResume(payload)),
        [dispatch]
    );

    const updateResume = useCallback(
        (payload) => dispatch(actions.updateResume(payload)),
        [dispatch]
    );
    const finishGetResume = useCallback(
      (payload) => dispatch(actions.finishGetResume(payload)),
      [dispatch]
    );

     const getResume = useCallback(
        (payload) => dispatch(actions.getResume(payload)),
        [dispatch]
      );

      const deleteResume = useCallback(
        (payload) => dispatch(actions.deleteResume(payload)),
        [dispatch]
      )
      const setBioResume = useCallback(
        (payload) => dispatch(actions.setBioResume(payload)),
        [dispatch]
      )


    return {
        initialize,
        resumes,
        setResumes,
        addResume,
        updateResume,
        refreshResumes,
        loadMore,
        limit,
        total,
        finishGetResume,
        getResume,
        isRequesting,
        deleteResume,
        bio,
        setBioResume,
        display_qr_reels
    };
} 